import { CacheService } from './app/_services/cache/cache.service';
import { GoogleAnalyticsService } from './app/_services/google-analytics/google-analytic.service';
import { provideLottieOptions } from 'ngx-lottie';
import { provideAppInitializer, inject, importProvidersFrom } from '@angular/core';
import { TranslocoService, TranslocoModule } from '@jsverse/transloco';
import { RegionService } from './app/_services/region/region.service';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RouteReuseStrategy } from '@angular/router';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { MyPagesRouteReuseStrategy } from './app/my-pages/my-pages-route-reuse.strategy';
import { AppRoutingModule } from './app/app-routing.module';
import { ErrorModule } from './app/_shared/error/error.module';

import { provideAnimations } from '@angular/platform-browser/animations';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { TranslocoRootModule } from './app/transloco-root.module';
import { AppComponent } from './app/app.component';
import { registerLocaleData } from '@angular/common';
import myLocaleSv from '@angular/common/locales/sv';
import myLocaleNo from '@angular/common/locales/no';
import myLocaleDa from '@angular/common/locales/da';

registerLocaleData(myLocaleSv);
registerLocaleData(myLocaleNo);
registerLocaleData(myLocaleDa);

// AoT requires an exported function for factories

export function initializeApp(translationService: TranslocoService) {
  return () => {
    const browserLang = navigator.language.split('-')[0]; // e.g., 'en', 'sv'
    const supportedLangs = ['sv', 'no', 'dk'];
    const defaultLang = supportedLangs.includes(browserLang) ? browserLang : 'no';
    translationService.setActiveLang(defaultLang);
  };
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      BrowserModule,
      AppRoutingModule,
      MatDatepickerModule,
      MatNativeDateModule,
      MatInputModule,
      ErrorModule,
      TranslocoModule,
      TranslocoRootModule,
    ),
    CacheService,
    GoogleAnalyticsService,
    RegionService,
    provideLottieOptions({
      player: () => import('lottie-web'),
    }),
    provideAppInitializer(() => {
      const initializerFn = initializeApp(inject(TranslocoService));
      // inject(RegionService)
      return initializerFn();
    }),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    { provide: RouteReuseStrategy, useClass: MyPagesRouteReuseStrategy },
  ],
})
  .then(() => {
    const skeleton = document.getElementById('skeleton');
    if (skeleton) {
      skeleton.remove(); // Remove the skeleton after Angular has bootstrapped
    }
  })
  .catch((err) => console.error(err));
